import styled from 'styled-components';

const BookingTooltip = styled.div`
  .tooltip {
    position: absolute;
    top: calc(50% - 170px);
    left: -140px;
    z-index: 100;
    width: 140px;
    height: auto;
    padding: 10px;
    visibility: hidden;
    opacity: 0;
    color: ${props => props.theme.colors.black};
    background-color: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.75);
    text-align: center;
    border-radius: 10px;
    overflow-x: visible;
    overfluw-y: hidden;

    &::after {
      content: '';
      position: absolute;
      z-index: -1;
      top: calc(50% - 10px);
      right: -10px;
      width: 20px;
      height: 20px;
      background-color: ${props => props.theme.colors.white};
      transform: rotate(45deg);
    }

    table {
      background-color: ${props => props.theme.colors.white};
      margin: 0 auto;
      border-radius: 10px;

      caption {
        margin-bottom: 6px;
        padding: 0;
        font-size: 12px;
        color: ${props => props.theme.colors.black};
        font-weight: 400;
      }

      thead {
        color: ${props => props.theme.colors.white};
        background-color: ${props => props.theme.colors.primary};

        .table__cell--header {
          height: 24px;
          font-size: 24px;
          line-height: 1;
          color: ${props => props.theme.colors.white};

          .text {
            display: none;
          }
        }

        .table__cell--header-time {
          background: ${props => props.theme.colors.primary}
            url('data:image/svg+xml;utf8,<svg height="512pt" viewBox="0 0 443.294 443.294" width="512pt" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="m221.647 0c-122.214 0-221.647 99.433-221.647 221.647s99.433 221.647 221.647 221.647 221.647-99.433 221.647-221.647-99.433-221.647-221.647-221.647zm0 415.588c-106.941 0-193.941-87-193.941-193.941s87-193.941 193.941-193.941 193.941 87 193.941 193.941-87 193.941-193.941 193.941z"/><path d="m235.5 83.118h-27.706v144.265l87.176 87.176 19.589-19.589-79.059-79.059z"/></svg>')
            50%/14px 14px no-repeat;
        }

        .table__cell--header-availability {
          background: ${props => props.theme.colors.primary}
            url('data:image/svg+xml;utf8,<svg height="626pt" viewBox="-33 -19 626 626.68002" width="626pt" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="m113.925781 286.375h193.75c6.902344 0 12.5-5.597656 12.5-12.5s-5.597656-12.5-12.5-12.5h-193.75c-6.90625 0-12.5 5.597656-12.5 12.5s5.59375 12.5 12.5 12.5zm0 0"/><path d="m229.921875 342.625h-115.996094c-6.90625 0-12.5 5.597656-12.5 12.5s5.59375 12.5 12.5 12.5h115.996094c6.902344 0 12.5-5.597656 12.5-12.5s-5.597656-12.5-12.5-12.5zm0 0"/><path d="m446.921875 314.871094v-215.996094c-.007813-34.515625-27.988281-62.488281-62.5-62.5h-51.25v-23.875c0-6.90625-5.59375-12.5-12.5-12.5-6.902344 0-12.5 5.59375-12.5 12.5v23.875h-170v-23.875c0-6.90625-5.59375-12.5-12.5-12.5-6.902344 0-12.5 5.59375-12.5 12.5v23.875h-51.25c-34.511719.011719-62.484375 27.984375-62.5 62.5v338.625c.015625 34.511719 27.988281 62.484375 62.5 62.5h231.378906c24.050781 61.601562 88.550781 97.359375 153.539063 85.125 64.988281-12.230469 112.074218-68.992188 112.085937-135.125.121094-67.125-48.253906-123.125-112.003906-135.128906zm-384.871094-253.496094h51.25v23.875c0 6.902344 5.59375 12.5 12.5 12.5 6.902344 0 12.5-5.597656 12.5-12.5v-23.875h170v23.875c0 6.902344 5.59375 12.5 12.5 12.5 6.902344 0 12.5-5.597656 12.5-12.5v-23.875h51.25c20.683594.058594 37.4375 16.8125 37.5 37.5v30.25h-397.5v-30.25c.015625-20.707031 16.796875-37.484375 37.5-37.5zm0 413.625c-20.6875-.058594-37.441406-16.816406-37.5-37.5v-283.5h397.371094v158.5h-.375c-40.824219.0625-79.515625 18.230469-105.632813 49.613281-26.121093 31.378907-36.964843 72.730469-29.617187 112.886719zm359.496094 87.5c-62.128906 0-112.5-50.367188-112.5-112.5s50.371094-112.5 112.5-112.5c62.132813 0 112.5 50.367188 112.5 112.5-.09375 62.09375-50.40625 112.40625-112.5 112.5zm0 0"/><path d="m479.421875 405.125-74.246094 70.875-38.378906-38.5c-4.863281-4.867188-12.753906-4.867188-17.621094 0-4.871093 4.867188-4.871093 12.757812 0 17.625l47.121094 47.125c2.34375 2.359375 5.546875 3.667969 8.878906 3.625 3.226563.027344 6.328125-1.230469 8.621094-3.503906l83-79.375c2.390625-2.285156 3.773437-5.421875 3.847656-8.730469.066407-3.308594-1.179687-6.507813-3.472656-8.890625-4.867187-4.882812-12.746094-4.996094-17.75-.25zm0 0"/></svg>')
            50%/18px 18px no-repeat;
        }
      }

      tr {
        height: 20px;

        tr {
          height: 10px;
        }
      }

      td,
      th {
        width: 50%;
        padding: 3px 5px;
        font-size: 12px;
        line-height: 1.2;
        color: ${props => props.theme.colors.black};
      }

      td {
        text-indent: -99999px;
        padding: 0 5px;
      }
    }

    .table__cell--booked {
      left: calc(50% - 10px);
      width: 20px;

      &.table__cell--second-half-hour {
        border-radius: ${props => props.theme.borderRadius}
          ${props => props.theme.borderRadius} 0 0;

        &.table__cell--end {
          border-radius: ${props => props.theme.borderRadius};
        }

        &.my__booking {
          background-image: repeating-linear-gradient(
            20deg,
            ${props => props.theme.colors.transparent},
            ${props => props.theme.colors.transparent} 55%,
            ${props => props.theme.colors.translucent} 55%,
            ${props => props.theme.colors.translucent} 100%
          );
        }
      }

      &.table__cell--first-half-hour {
        border-radius: 0 0 ${props => props.theme.borderRadius}
          ${props => props.theme.borderRadius};

        &.table__cell--start {
          border-radius: ${props => props.theme.borderRadius};
        }

        &.my__booking {
          background-image: repeating-linear-gradient(
            20deg,
            ${props => props.theme.colors.translucent},
            ${props => props.theme.colors.translucent} 45%,
            ${props => props.theme.colors.transparent} 45%,
            ${props => props.theme.colors.transparent} 100%
          );
        }
      }
    }
  }
`;

export { BookingTooltip };
